
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 9a.75.75 0 01-.75-.75V7.5h-1.5v.75a.75.75 0 01-1.5 0v-3C3.75 4.009 4.759 3 6 3s2.25 1.009 2.25 2.25v3A.75.75 0 017.5 9zm-.75-3v-.75a.75.75 0 00-1.5 0V6h1.5zM19.443 17.248a4.717 4.717 0 01-2.96-1.334c-.906.887-1.908 1.336-2.983 1.336a.75.75 0 010-1.5c1.64 0 2.792-1.816 3.369-3H13.5a.75.75 0 010-1.5h2.25v-.75a.75.75 0 011.5 0v.75h2.25a.75.75 0 010 1.5h-.983a11.138 11.138 0 01-1.069 1.998 3.192 3.192 0 002.103 1.004.74.74 0 01.514.255.75.75 0 01-.565 1.243l-.057-.002z"}}),_c('path',{attrs:{"d":"M20.25 24a.743.743 0 01-.53-.22l-4.28-4.28h-4.19A2.252 2.252 0 019 17.25v-7.5a2.252 2.252 0 012.25-2.25h10.5A2.252 2.252 0 0124 9.75v7.5a2.252 2.252 0 01-2.25 2.25H21v3.75a.75.75 0 01-.75.75zm-9-15a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h4.5c.198 0 .391.08.53.22l3.22 3.22v-2.69a.75.75 0 01.75-.75h1.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75h-10.5z"}}),_c('path',{attrs:{"d":"M3.75 16.5a.75.75 0 01-.75-.75V12h-.75A2.252 2.252 0 010 9.75v-7.5A2.252 2.252 0 012.25 0h10.5A2.252 2.252 0 0115 2.25v3a.75.75 0 01-1.5 0v-3a.75.75 0 00-.75-.75H2.25a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h1.5a.75.75 0 01.75.75v2.689l1.72-1.72a.746.746 0 011.06.001.752.752 0 010 1.061l-3 3a.746.746 0 01-.53.219z"}})])
          )
        }
      }
    